import script from "./AdminOSSManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOSSManager.vue?vue&type=script&setup=true&lang=js"

import "./AdminOSSManager.vue?vue&type=style&index=0&id=546b9c24&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546b9c24"]])

export default __exports__